import React from 'react';
import { TrendingUp, CreditCard, Package, Truck } from 'lucide-react';

/**
 * 가맹점 대시보드 (목업 데이터)
 * - API 연동 없이 고정 값만 표시
 */
function Dashboard() {
  const todayLabel = (() => {
    const now = new Date();
    return `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일`;
  })();

  return (
    <div className="flex-1 min-h-0 py-5 px-8 overflow-auto space-y-4">
      {/* 금일 매출 */}
      <section className="pb-8">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-[18px] font-bold text-[#191f28] leading-[42px]">
            금일 매출 ({todayLabel})
          </h2>
          <div className="flex items-center gap-2">
            <span className="text-[22px] font-black text-[#191f28]">
              3,456,789원
            </span>
            <div className="flex items-center gap-1 text-[#0064ff] font-bold text-[16px]">
              <TrendingUp size={16} /> +1.2%
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div className="bg-white rounded p-4 flex flex-col border border-[#e0e0e0] shadow-md">
            <span className="text-[18px] font-bold text-[#8b95a1] mb-2">
              주간 매출 추이
            </span>
            <div className="flex-1 relative flex items-end px-1 pb-1">
              <svg
                className="w-full h-[75%]"
                viewBox="0 0 400 100"
                preserveAspectRatio="none"
              >
                <path
                  d="M0,80 L60,65 L120,75 L180,40 L240,55 L300,20 L360,15 L400,25"
                  fill="none"
                  stroke="#0064ff"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
          <div className="bg-white rounded p-4 flex flex-col border border-[#e0e0e0] shadow-md">
            <span className="text-[18px] font-bold text-[#4e5968] mb-2">
              월간 매출 추이
            </span>
            <div className="flex-1 relative flex items-end px-1 pb-1">
              <svg
                className="w-full h-[75%]"
                viewBox="0 0 400 100"
                preserveAspectRatio="none"
              >
                <path
                  d="M0,70 L100,50 L200,30 L300,45 L400,15"
                  fill="none"
                  stroke="#04c084"
                  strokeWidth="5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>
      </section>

      {/* 간단 카드 요약 */}
      <div className="grid grid-cols-3 gap-4">
        <div className="bg-white rounded-2xl p-6 border border-[#e0e0e0] shadow-md flex items-center gap-4">
          <div className="w-14 h-14 bg-[#e7f5ff] rounded-xl flex items-center justify-center">
            <CreditCard className="text-[#0064ff] w-7 h-7" />
          </div>
          <div>
            <span className="text-[18px] font-bold text-[#8b95a1]">오늘 결제</span>
            <p className="text-[22px] font-black text-[#191f28]">42건</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl p-6 border border-[#e0e0e0] shadow-md flex items-center gap-4">
          <div className="w-14 h-14 bg-[#e6fcf5] rounded-xl flex items-center justify-center">
            <Package className="text-[#04c084] w-7 h-7" />
          </div>
          <div>
            <span className="text-[18px] font-bold text-[#8b95a1]">배송 대기</span>
            <p className="text-[22px] font-black text-[#191f28]">8건</p>
          </div>
        </div>
        <div className="bg-white rounded-2xl p-6 border border-[#e0e0e0] shadow-md flex items-center gap-4">
          <div className="w-14 h-14 bg-[#fff7e6] rounded-xl flex items-center justify-center">
            <Truck className="text-[#ff9500] w-7 h-7" />
          </div>
          <div>
            <span className="text-[18px] font-bold text-[#8b95a1]">배송중</span>
            <p className="text-[22px] font-black text-[#191f28]">3건</p>
          </div>
        </div>
      </div>

      {/* 최근 결제 내역 (목업) */}
      <section className="bg-white rounded p-6 border border-[#e0e0e0] shadow-md">
        <h2 className="text-[18px] font-bold text-[#191f28] mb-4">최근 결제 내역</h2>
        <div className="space-y-3">
          {[
            { name: '김고객', amount: '45,200원', date: '26.01.29 18:20' },
            { name: '이고객', amount: '12,500원', date: '26.01.29 18:15' },
          ].map((item, i) => (
            <div
              key={i}
              className="flex justify-between py-3 border-b border-[#f2f4f6]"
            >
              <span className="font-medium text-[18px] text-[#191f28]">
                {item.name}
              </span>
              <span className="font-bold text-[18px] text-[#0064ff]">
                {item.amount}
              </span>
              <span className="text-[16px] text-[#8b95a1]">{item.date}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Dashboard;
